import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const galleryImages = document.querySelectorAll('[data-fancybox="gallery"]');
galleryImages.forEach((galleryImage) => {
	const image = galleryImage.firstElementChild as HTMLImageElement;
	galleryImage.setAttribute('data-src', image.src);
});

Fancybox.bind('[data-fancybox="gallery"]', {
	
}); 
